/**
 * Interface para serviços de detecção de plataforma
 */

import { BasePlatformService, ServiceCapabilities } from './base_platform_service';

export enum PlatformType {
  WEB = 'web',
  MOBILE_WEB = 'mobile_web',
  PWA = 'pwa',
  ELECTRON = 'electron',
  WEBVIEW = 'webview'
}

export enum BrowserType {
  CHROME = 'chrome',
  FIREFOX = 'firefox',
  SAFARI = 'safari',
  EDGE = 'edge',
  OPERA = 'opera',
  SAMSUNG = 'samsung',
  UNKNOWN = 'unknown'
}

export interface PlatformInfo {
  type: PlatformType;
  browser: BrowserType;
  version: string;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  userAgent: string;
  capabilities: ServiceCapabilities;
}

export interface IPlatformDetectionService extends BasePlatformService {
  readonly serviceName: 'PlatformDetection';
  
  getPlatformInfo(): PlatformInfo;
  refreshPlatformInfo(): void;
  isBrowser(browser: BrowserType): boolean;
  isPlatformType(type: PlatformType): boolean;
  getCapabilities(): ServiceCapabilities;
}
